// A quiet loader in the page's theme: the accent spinner and a muted label, no grey veil (owner 2026-10-26:
// the old white-30% veil read as a grey bar on the dark sign-in card and over the dark preview).
.loadingOverlay {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--axl-text-3, #8c8c8c);

  .icon {
    color: var(--axl-primary, #3366ff);
  }

  &[data-position="absolute"] {
    width: 100vw;
    height: 100vh;
  }

  &[data-position="relative"],
  &[data-position="overlay"],
  &[data-position="fixed"] {
    width: 100%;
    height: 100%;
  }

  // in a block that sizes to its content (the sign-in card): room for the spinner, not a thin strip
  &[data-position="relative"] {
    min-height: 120px;
  }

  &[data-position="overlay"] {
    position: absolute;
  }

  &[data-position="fixed"] {
    position: fixed;
  }

  &[data-position="absolute"],
  &[data-position="overlay"],
  &[data-position="fixed"] {
    z-index: 999;
  }

  // only an overlay covers content, so only it gets a (theme-coloured) veil
  &[data-theme="light"][data-position="overlay"] {
    background: color-mix(in srgb, var(--axl-surface, #fff) 55%, transparent);
  }

  &[data-theme="dark"] {
    color: #fff;
    background: #1c1c1c;
  }

  &[data-size="small"] {
    font-size: 14px;

    .icon {
      font-size: 16px;
    }
  }

  &[data-size="middle"] {
    font-size: 16px;

    .icon {
      font-size: 20px;
    }
  }

  &[data-size="large"] {
    font-size: 18px;

    .icon {
      font-size: 24px;
    }
  }

  &[data-animation="true"] {
    animation: fadeIn 0.2s;
  }
}

@keyframes fadeIn {

  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
